import { Accordion, Divider, Flex, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { WinnerContent } from './WinnerContent';

interface ExpanderItem {
  Title: string;
  Content: string[];
}

interface WinnerSection {
  Title: string;
  Description: string;
  NextStepsTitle: string;
  NextSteps: string[];
  ClosingText: string;
}

type AccordionItem =
  | { type: 'winner'; Title: string }
  | { type: 'regular'; Title: string; Content: string[] };

export const RaffleExpander = ({
  endDate,
  hasWon,
}: {
  endDate: string;
  hasWon: boolean;
}) => {
  const { t } = useTranslation('raffle');

  const expanderData = t('ExpanderDetails', {
    returnObjects: true,
    endDate: endDate,
  }) as ExpanderItem[];

  const winnerSection = t('WinnerSection', {
    returnObjects: true,
  }) as WinnerSection;

  // if participant has won, show winner section first, then the regular sections. Otherwise, just show the regular sections
  const accordionItems: AccordionItem[] = hasWon
    ? [
        { type: 'winner', Title: winnerSection.Title },
        ...expanderData.map((item) => ({ type: 'regular' as const, ...item })),
      ]
    : expanderData.map((item) => ({ type: 'regular' as const, ...item }));

  return (
    <div>
      <Divider />

      <Accordion defaultValue={accordionItems[0].Title}>
        {accordionItems.map((item) => (
          <Accordion.Item key={item.Title} value={item.Title}>
            <Accordion.Control py="10px">
              <Text size="21px" lh="24px" fw="600" c="#202020">
                {item.Title}
              </Text>
            </Accordion.Control>
            <Accordion.Panel>
              {item.type === 'winner' ? (
                <WinnerContent
                  description={winnerSection.Description}
                  nextStepsTitle={winnerSection.NextStepsTitle}
                  nextSteps={winnerSection.NextSteps}
                  closingText={winnerSection.ClosingText}
                />
              ) : (
                <Flex gap="10px" direction="column">
                  {item.Content.map((content, index) => (
                    <Text key={index} size="16px" lh="24px" c="#202020">
                      {content}
                    </Text>
                  ))}
                </Flex>
              )}
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
};
